import type { ScrollPosition } from './types';

/**
 * The shell's `js_` hooks are required markup; a miss means a broken include
 * rather than a runtime state worth handling.
 */
export const requireElement = <T extends Element>(root: ParentNode, selector: string): T => {
    const element = root.querySelector<T>(selector);
    if (!element) {
        throw new Error(`brand-alerts: required element not found: ${selector}`);
    }
    return element;
};

export const getScrollPosition = (element: Element): ScrollPosition => ({
    scrollHeight: element.scrollHeight,
    scrollTop: element.scrollTop,
    clientHeight: element.clientHeight,
});
